module.exports = __webpack_public_path__ + "static/media/wink-mobile-screens.59fdd03c.png";